module.exports = angular.module('cartographer.plugin.layer.nwc', [])

_ = require 'underscore'

module.exports.run $DI (
  crtLayer
  nwcSeedbankLayer
) ->
  crtLayer.registerPlugin(nwcSeedbankLayer)
  return

module.exports.factory "nwcSeedbankLayer", $DI (
  crtMarkerColor
  crtFeatureLayer
  crtAttributeLayer
  crtMapCollaborationModel
  crtMapPermissionModel
  nwcSeedbankCollection
  nwcSeedbankSpecies
  nwcSeedbankArea
  nwcSeedbankLandUse
  nwcSeedbankVegetation
  nwcSeedbankSoilType
  nwcSeedbankProblemPlantSpecies
  nwcSeedbankEvidenceOfPollution
) ->
  speciesColor = (species) ->
    switch species
      when "Betony"                  then  "#be6ff7"
      when "BirdsfootTrefoil"        then  "#f7cffc"
      when "Bluebell"                then  "#646bf6"
      when "CommonCatsEar"           then  "#b1facf"
      when "CommonKnapweed"          then  "#ea3ef7"
      when "CornChamomile"           then  "#fffed1"
      when "CornMarigold"            then  "#fffd54"
      when "CornPoppy"               then  "#eb3223"
      when "CommonSorrel"            then  "#b8902f"
      when "Corncockle"              then  "#bb30c5"
      when "Cornflower"              then  "#3f99f7"
      when "CowParsley"              then  "#fffed1"
      when "CrestedDogsTail"         then  "#f29d38"
      when "DevilsBitScabious"       then  "#73fbfd"
      when "FieldScabious"           then  "#ed72c8"
      when "Foxglove"                then  "#eb4a97"
      when "GreaterBirdsfootTrefoil" then  "#f8cd76"
      when "HedgeBedstraw"           then  "#b1f97b"
      when "LadysBedstraw"           then  "#eaeaea"
      when "MeadowButtercup"         then  "#f8cb46"
      when "Meadowsweet"             then  "#f7cecd"
      when "MuskMallow"              then  "#989bf8"
      when "OxeyeDaisy"              then  "#ffffff"
      when "PurpleLoosestrife"       then  "#5c1fc4"
      when "RaggedRobin"             then  "#be3f1e"
      when "RedCampion"              then  "#bb2965"
      when "RedClover"               then  "#8c3b64"
      when "RibwortPlantain"         then  "#8c3816"
      when "SelfHeal"                then  "#8b26c3"
      when "TuftedVetch"             then  "#0839c4"
      when "VipersBugloss"           then  "#5c1fc4"
      when "WildCarrot"              then  "#d5fda4"
      when "Yarrow"                  then  "#c39a33"
      when "YellowFlagIris"          then  "#fefc7e"
      when "YellowRattle"            then  "#cbc942"
      when "Other"                   then  "#ffcc00"
      else                                 "#ffcc00"

  crtFeatureLayer.create({
    id: "NwcSeedbank"
    name: "Wildflower Warriors"
    atlasMapId: "NwcSeedbank"
    defaultMapEngine: "atlas"
    enableHistogram: false
    enableTimeline: false
    selectionRadius: 500
    attributeGroups: [
      crtFeatureLayer.createAttributeGroup("collection", "Seed Collection", [
        crtAttributeLayer.createEnumLookup("collection", "Seed Collection", null, nwcSeedbankCollection)
      ])
      crtFeatureLayer.createAttributeGroup "species", "Wildflower Species", nwcSeedbankSpecies.values.map (species) ->
        crtAttributeLayer.createLookup("species#{species.id}", species.name, null, [
          { value: true, color: crtMarkerColor.create(speciesColor(species.id)), label: "Yes (Species Observed)" }
          { value: true, color: crtMarkerColor.blank, label: "No (Species Not Observed)" }
        ])
      crtFeatureLayer.createAttributeGroup("area", "Area", [
        crtAttributeLayer.createEnumLookup("area", "Approx Area", "m2", nwcSeedbankArea)
      ])
      crtFeatureLayer.createAttributeGroup("landUse", "Land Use", [
        crtAttributeLayer.createEnumLookup("dominantLandUse", "Dominant Land Use", null, nwcSeedbankLandUse)
      ])
      crtFeatureLayer.createAttributeGroup("vegetation", "Vegetation", [
        crtAttributeLayer.createEnumLookup("dominantVegetation", "Dominant Vegetation", null, nwcSeedbankVegetation)
      ])
      crtFeatureLayer.createAttributeGroup("soilType", "Soil Type", [
        crtAttributeLayer.createEnumLookup("dominantSoilType", "Dominant Soil Type", null, nwcSeedbankSoilType)
      ])
      crtFeatureLayer.createAttributeGroup("problemPlantSpecies", "Problem Plant Species", [
        crtAttributeLayer.createEnumLookup("problemPlantSpecies", "Problem Plant Species", null, nwcSeedbankProblemPlantSpecies)
      ])
      crtFeatureLayer.createAttributeGroup("wildlife", "Wildlife Spotted", [
        crtAttributeLayer.createBooleanLookup("wildlifeSpottedPollinators", "Pollinator Species")
        crtAttributeLayer.createBooleanLookup("wildlifeSpottedOther", "Other Wildlife Species")
      ])
    ]
  })
